<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane label="启动图列表" name="1" link="/operation/startupDiagram/list"></el-tab-pane>
            <el-tab-pane label="启动图排期" v-if="$utils.have('/diagram/advertisement/list')" name="2" link="/operation/startupDiagram/schedule"></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props:{
        name:{
            type: String,
            default: '1'
        }
    },
    data(){
        return{
            activeName: this.name
        }
    },
    methods:{
        clickEvent(tab){
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link)
        }
    }
}
</script>